import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditTourPayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editTour = createSlice({
    name: 'tour/edit-tour',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IEditTourPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editTourActions = editTour.actions
export default editTour.reducer
